import React, { Component } from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import _ from "i18n";
import { selectCurrentOrganization } from "Selectors";
import { createdDateFormat } from "Utils";
import Slide from "../Dashboard/Slide";
import { HideEye, ICONS, SvgIcon } from "../Common/Icons";
import styles from "./SlideItem.local.scss";
import { getLabelsByLng } from "../../utils";

class SlideItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovering: false
    };
  }
  handleMouseOver = () => {
    this.setState({ isHovering: true });
  };
  handleMouseOut = () => {
    this.setState({
      isHovering: false
    });
  };
  render() {
    const {
      slide,
      lng,
      extraSlidesInModal,
      backOffice,
      allowUpdateSlide,
      currentOrganization,
      withoutHeader,
      newTag,
      closeNewTag,
      filterStatus
    } = this.props;
    return (
      <div className={classnames("columns medium-3", styles.slide_item)}>
        <ul>
          <li
            className={
              extraSlidesInModal
                ? classnames(styles.slide_card, styles.in_modal)
                : styles.slide_card
            }
            style={
              ({ background: slide.hidden ? "#f5f5f5" : "#F8F9FA" },
              { width: withoutHeader ? "310px" : "320px" })
            }
            onMouseOver={this.handleMouseOver}
            onMouseOut={this.handleMouseOut}
          >
            {newTag &&
              newTag.notifications.map(notification => {
                return (
                  !this.state.isHovering &&
                  !closeNewTag &&
                  notification.slideId === slide.id && (
                    <div className={styles.newTag}>
                      <span>{_("new")}</span>
                    </div>
                  )
                );
              })}
            <div
              className={styles.slide_container}
              style={{ background: slide.hidden ? "#f5f5f5" : "#F8F9FA" }}
            >
              <div className={styles.item}>
                <Slide key={slide.id} slide={slide} isResponsive={false} />
              </div>
            </div>
            {!extraSlidesInModal ? (
              <div
                style={{ background: slide.hidden ? "#f5f5f5" : "#FFFFFF" }}
                className={classnames(
                  styles.informations_container,
                  this.state.isHovering && styles.information_icon
                )}
              >
                <div>
                  <div>
                    <div className={styles.information_bloc}>
                      <h2 className={styles.title}>
                        {slide.layout.type === "EXTRA_SLIDE"
                          ? slide.label.substring(0, 15)
                          : getLabelsByLng(slide.labels, lng).length > 25 &&
                            !this.state.isHovering
                            ? getLabelsByLng(slide.labels, lng).substring(
                                0,
                                15
                              ) + " ..."
                            : getLabelsByLng(slide.labels, lng)}
                      </h2>
                      <div className={styles.date}>
                        <span>
                          {_("createdAt")}{" "}
                          {createdDateFormat(slide.createdAt, lng)} <br />
                        </span>
                        <span>
                          {slide.organization !== "STANDARD" &&
                          slide.originOrganization
                            ? _("by") + " " + slide.originOrganization
                            : slide.organization === "STANDARD"
                              ? _("standard")
                              : _("by") + " " + slide.organization}
                        </span>
                      </div>
                    </div>
                    <div className={styles.flags}>
                      {slide.labels.fr.length > 0 && (
                        <img src="/img/icons/fr_flag.svg" alt="" />
                      )}
                      {slide.labels.nl.length > 0 && (
                        <img src="/img/icons/nl_flag.svg" alt="" />
                      )}
                      {slide.labels.en.length > 0 && (
                        <img src="/img/icons/en_flag.svg" alt="" />
                      )}
                    </div>
                  </div>
                  <div className={styles.status}>
                    {slide.isPublic === true ? (
                      <div className={styles.tags}>
                        {slide.status != "STANDARD" ? (
                          <div>
                            <SvgIcon
                              icon={ICONS.Share}
                              className={styles.statusIcon}
                            />
                            <span>{_("share")}</span>
                          </div>
                        ) : (
                          <div>
                            <SvgIcon
                              icon={ICONS.Standard}
                              className={styles.statusIcon}
                            />
                            <span>{_("standard")}</span>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className={styles.tags}>
                        <SvgIcon
                          icon={ICONS.Lock}
                          className={styles.statusIcon}
                        />
                        <span>{_("private")}</span>
                      </div>
                    )}
                    {slide.status != "STANDARD" && (
                      <div style={{ display: "inline" }}>
                        {slide.isOriginal === true ? (
                          <div className={styles.tags}>
                            <SvgIcon
                              icon={ICONS.Original}
                              className={styles.statusIcon}
                            />
                            <span>{_("original")}</span>
                          </div>
                        ) : (
                          <div className={styles.tags}>
                            <SvgIcon
                              icon={ICONS.Duplicated}
                              className={styles.statusIcon}
                            />
                            <span>{_("duplicated")}</span>
                          </div>
                        )}
                      </div>
                    )}
                    <div
                      className={classnames(styles.more_information)}
                      style={{ display: !this.state.isHovering && "none" }}
                    >
                      <div className={styles.actions_container}>
                        {(slide.status === "CREATED" || backOffice) &&
                        slide.layout.type !== "EXTRA_SLIDE" ? (
                          <div>
                            {this.props.filterValue !== "SHARED" &&
                            currentOrganization.uen ===
                              slide.organizationUen ? (
                              <div>
                                <div
                                  className={classnames(
                                    "d-flex align-items-center justify-content-center",
                                    styles.actions,
                                    getLabelsByLng(slide.labels, lng).length >
                                    50
                                      ? styles.action_position
                                      : styles.action_position_hover
                                  )}
                                >
                                  {allowUpdateSlide && (
                                    <div
                                      onClick={() =>
                                        this.props.handleDisplayUpdateSlide(
                                          slide
                                        )
                                      }
                                    >
                                      <SvgIcon
                                        icon={ICONS.EDIT_ICON}
                                        className={""}
                                      />
                                    </div>
                                  )}
                                  <div
                                    onClick={() =>
                                      this.props.duplicateSlide(slide.id)
                                    }
                                  >
                                    <SvgIcon
                                      icon={ICONS.DUPLICATE_ICON}
                                      className={""}
                                    />
                                  </div>
                                  {!slide.isPublic ? (
                                    <div
                                      onClick={() =>
                                        this.props.sharedSlide(
                                          slide.id,
                                          slide.isEditable
                                        )
                                      }
                                    >
                                      <SvgIcon icon={ICONS.Share} />
                                    </div>
                                  ) : (
                                    <div
                                      onClick={() =>
                                        this.props.handleSetSlidePrivate(
                                          slide.id
                                        )
                                      }
                                    >
                                      <SvgIcon icon={ICONS.Unshared} />
                                    </div>
                                  )}
                                </div>
                                <div
                                  className={classnames(
                                    "d-flex align-items-center justify-content-center",
                                    styles.actions
                                  )}
                                >
                                  <div
                                    onClick={() =>
                                      this.props.deleteSlide(slide.id)
                                    }
                                    className={classnames(styles.delete_action)}
                                  >
                                    <SvgIcon
                                      icon={ICONS.DELETE_ICON}
                                      className={""}
                                    />
                                  </div>
                                </div>
                              </div>
                            ) : !backOffice ? (
                              <div
                                className={classnames(
                                  styles.actions,
                                  getLabelsByLng(slide.labels, lng).length > 50
                                    ? styles.action_position_created
                                    : styles.action_position_created_hover
                                )}
                              >
                                {!(
                                  filterStatus === "Templates" ||
                                  filterStatus === "MyTemplates"
                                ) ? (
                                  <div
                                    onClick={() =>
                                      slide.isEditable
                                        ? this.props.changeStateSlide(
                                            slide.id,
                                            currentOrganization.uen
                                          )
                                        : this.props.handleUseSharedSlide(
                                            slide.id,
                                            currentOrganization.uen
                                          )
                                    }
                                  >
                                    <SvgIcon
                                      icon={ICONS.SIMPLE_PLUS_ICON}
                                      className={""}
                                    />
                                  </div>
                                ) : null}
                              </div>
                            ) : (
                              <div
                                className={classnames(
                                  "d-flex align-items-center justify-content-center",
                                  styles.actions,
                                  getLabelsByLng(slide.labels, lng).length > 50
                                    ? styles.action_position_created
                                    : styles.action_position_created_hover
                                )}
                              >
                                {allowUpdateSlide && (
                                  <div
                                    onClick={() =>
                                      this.props.handleDisplayUpdateSlide(slide)
                                    }
                                  >
                                    <SvgIcon
                                      icon={ICONS.EDIT_ICON}
                                      className={""}
                                    />
                                  </div>
                                )}
                                <div
                                  onClick={() =>
                                    this.props.duplicateSlide(slide.id)
                                  }
                                >
                                  <SvgIcon
                                    icon={ICONS.DUPLICATE_ICON}
                                    className={""}
                                  />
                                </div>
                                <div
                                  onClick={() =>
                                    this.props.deleteSlide(slide.id)
                                  }
                                  className={classnames(styles.delete_action)}
                                >
                                  <SvgIcon
                                    icon={ICONS.DELETE_ICON}
                                    className={""}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        ) : slide.status === "CREATED" ? (
                          <div className={`row ${styles.actions} `}>
                            <div
                              onClick={() =>
                                this.props.handleDisplayUpdateExtraSlide({
                                  slide
                                })
                              }
                            >
                              <SvgIcon icon={ICONS.EDIT_ICON} className={""} />
                            </div>
                            <div onClick={() => this.props.hideSlide(slide)}>
                              {slide.hidden ? (
                                <HideEye
                                  className={classnames(styles.hidden)}
                                />
                              ) : (
                                <SvgIcon icon={ICONS.EyeIcon} className={""} />
                              )}
                            </div>
                            <div
                              onClick={() =>
                                this.props.duplicateSlide(slide.id)
                              }
                            >
                              <SvgIcon
                                icon={ICONS.DUPLICATE_ICON}
                                className={""}
                              />
                            </div>
                            <div
                              onClick={() => this.props.sharedSlide(slide.id)}
                            >
                              <SvgIcon icon={ICONS.Share} className={""} />
                            </div>
                            <div
                              onClick={() => this.props.deleteSlide(slide.id)}
                              className={classnames(styles.delete_action)}
                            >
                              <SvgIcon
                                icon={ICONS.DELETE_ICON}
                                className={""}
                              />
                            </div>
                          </div>
                        ) : (
                          <div
                            className={classnames(
                              styles.actions,
                              getLabelsByLng(slide.labels, lng).length > 50
                                ? styles.action_position_created
                                : styles.action_position_created_hover
                            )}
                          >
                            <div
                              onClick={() =>
                                this.props.duplicateSlide(slide.id)
                              }
                            >
                              <SvgIcon
                                icon={ICONS.DUPLICATE_ICON}
                                className={""}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className={classnames(
                  styles.informations_container,
                  styles.list_extra_slides
                )}
                style={{ background: slide.hidden ? "#f5f5f5" : "#ffffff" }}
              >
                <div
                  style={{
                    width: "240px",
                    display: "flex",
                    justifyContent: "space-between"
                  }}
                >
                  <h2 className={styles.title}>{slide.label} </h2>

                  <div
                    className={styles.more_information}
                    style={{ marginLeft: 152, marginTop: -18 }}
                  >
                    <div className={styles.actions_container}>
                      {
                        <div className={`row ${styles.actions} `}>
                          <div
                            onClick={() =>
                              this.props.changeStateSlide(
                                slide.id,
                                currentOrganization.uen
                              )
                            }
                          >
                            <SvgIcon
                              icon={ICONS.SIMPLE_PLUS_ICON}
                              className={""}
                            />
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            )}
          </li>
        </ul>
      </div>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  slides: state.dashboardComposition.slides,
  lng: state.params.lng,
  extraSlidesInModal: state.preparePresentation.extraSlidesInModal,
  backOffice: state.params.backOffice,
  currentOrganization: selectCurrentOrganization(state),
  withoutHeader: state.auth.withoutHeader,
  filterStatus: state.slideList.filterStatus
});

export default connect(mapStateToProps)(SlideItem);



// WEBPACK FOOTER //
// ./src/components/SlideList/SlideItem.js